module.exports = __webpack_public_path__ + "static/media/C014.ceb7ea42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C014.jpg
// module id = 297
// module chunks = 0